import React, { useEffect } from "react";
import * as d3 from "d3";

interface SalaryVersusTimeJobSalaryLineProps {
    xScale: d3.ScaleLinear<number, number>;
    jobSalary: {
        percentile: number;
        salary: number;
    };
    height: number;
    margin: number;
    mobile: boolean;
    d3Id: string;
}

export const SalaryVersusTimeJobSalaryLine = (
    props: SalaryVersusTimeJobSalaryLineProps
) => {
    const { xScale, jobSalary, height, margin, mobile, d3Id } = props;

    useEffect(() => {
        // the actual line on the chart
        d3.select(`#${d3Id}`)
            .selectAll(".jobSalaryLine")
            .append("line")
            .attr("x1", xScale(jobSalary.percentile))
            .attr("y1", mobile ? 0 : -15)
            .attr("x2", xScale(jobSalary.percentile))
            .attr("y2", height - margin * 2)
            .attr("stroke-width", mobile ? 3 : 0.75)
            .attr("stroke", "#E35AFC");

        {
            mobile
                ? null
                : // writing out the salary
                  d3.select(`#${d3Id}`)
                      .selectAll(".jobSalaryLine")
                      .append("g")
                      .selectAll("val")
                      .data([jobSalary])
                      .enter()
                      .append("text")
                      .html(d => d3.format("$,.2f")(d.salary))
                      .style("fill", "#E35AFC")
                      .attr("font-size", 8)
                      .attr("font-weight", 400)
                      .attr("y", -10)
                      .attr("x", d => xScale(d.percentile) + 5);

            // writing the constant "Your Job's Salary" text
            d3.select(`#${d3Id}`)
                .selectAll(".jobSalaryLine")
                .append("g")
                .selectAll("description")
                .data([jobSalary])
                .enter()
                .append("text")
                .html(d => "Your Job's Salary")
                .style("fill", "#222222")
                .attr("font-family", "'hkgrotesk_regular'")
                .style("opacity", 0.8)
                .attr("font-size", 5)
                .attr("font-weight", 200)
                .attr("y", -20)
                .attr("x", d => xScale(d.percentile) + 5);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <g className="jobSalaryLine"></g>;
};
